import React, { useState } from "react";
import { Modal, Flex, Tabs, Divider, Button, message, Upload} from "antd";
import CustomAvatar from "../../../Components/CustomAvatar";
import useAppStore, { setProfileFlag } from "../../../store";
import ApiService from "../../../API/apiService";
import { API_ENDPOINTS } from "../../../API/endpoints";
import Password from "antd/es/input/Password";

const ProfileModal = () => {
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [activeTabProfileModal, setActiveTabProfileModal] = useState("1");
  const [fileList, setFileList] = useState(null);
  const [Error, setError] = useState('');


  
  const [fields, setFields] = useState({
    fullName: { value: "First Name", isEditing: false },
    userName: { value: "first.name", isEditing: false },
    position: {
      value: "Click 'Edit' to add your job title/position",
      isEditing: false,
    },
    profilePicture: { value: "", isEditing: false, preview: "" },
    password: { value: "password", isEditing: false },
  });

  const profileFlag = useAppStore((state) => state.profileFlag);
  const [userData, setUserData] = useState(
    localStorage.getItem("userData")
      ? JSON.parse(localStorage.getItem("userData"))
      : ""
  );

  React.useEffect(() => {
    if (profileFlag) {
      setIsProfileModalOpen(true);
    }
  }, [profileFlag]);

  const handleProfileSettingsModalClose = () => {
    setIsProfileModalOpen(false);
    setProfileFlag(false);
    setFields({
      fullName: { value: "First Name", isEditing: false },
      userName: { value: "first.name", isEditing: false },
      position: {
        value: "Click 'Edit' to add your job title/position",
        isEditing: false,
      },
      profilePicture: { value: "", isEditing: false, preview: "" },
      password: { value: "password", isEditing: false },
    });
  };

  const handleEditToggle = (field) => {
    setFields((prevFields) => {
      const updatedFields = Object.keys(prevFields).reduce((acc, key) => {
        acc[key] = { ...prevFields[key], isEditing: false };
        return acc;
      }, {});

      return {
        ...updatedFields,
        [field]: {
          ...prevFields[field],
          isEditing: !prevFields[field].isEditing,
          value: userData[field] || prevFields[field].value,
        },
      };
    });
  };

  const handleChange = (field, value) => {
    if (field === "userName") {
      value = value.replace(/\s+/g, "_"); // Replace spaces with underscores
    }
    if (field === "password") {
         if (/\s/.test(value)) {
        setError("Space not allowed in password");
      }else{setError('')}
    }
    setFields((prevFields) => ({
      ...prevFields,
      [field]: { ...prevFields[field], value: value },
    }));
  };

  const handleFaviconUpload = async ({ file, onSuccess, onError }) => {
    try {
      const formData = new FormData();
      formData.append("image", file);

      const response = await ApiService.post(
        "/upload/uploadFile?file_for=profile_picture",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response?.statusCode === 200) {
        // The response structure shows data is an array with the first item containing the URLs
        const uploadData = response.data[0];
        const { originalUrl, thumbnailUrl } = uploadData;
        
        message.success(response.message);

        // Update preview in state immediately
        setFields((prevFields) => ({
          ...prevFields,
          profilePicture: {
            ...prevFields.profilePicture,
            value: originalUrl,
            preview: thumbnailUrl || originalUrl, // Use thumbnail if available
          },
        }));

      

        // Now update the user profile with the new image
        await handleProfileEdit("profile_picture", {
          url: originalUrl,
          thumbnailUrl: thumbnailUrl
        });

        onSuccess(response.data, file);
      } else {
        message.error("Image upload failed");
        onError(new Error("Upload failed"));
      }
    } catch (error) {
      console.error("Upload error:", error);
      message.error(error?.response?.data?.message || "An error occurred while uploading the image");
      onError(error);
    }
  };

  const handleProfileEdit = async (field, value) => {
    let reqBody;

    // Special handling for profile picture
    if (field === "profile_picture") {
      reqBody = {
        profile_picture: value, // This should be the object with url and thumbnailUrl
        user_id: userData?._id,
      };
    } else {
      reqBody = {
        [field]: fields[field].value,
        user_id: userData?._id,
      };
    }

   

    try {
      const response = await ApiService.post(
        API_ENDPOINTS.updateUserDetails,
        reqBody,
      );
      
     

      if (response.statusCode === 200) {
        setFields((prevFields) => ({
          ...prevFields,
          [field === "profile_picture" ? "profilePicture" : field]: { 
            ...prevFields[field === "profile_picture" ? "profilePicture" : field], 
            isEditing: false 
          },
        }));

        const apiData = response.data;
        const localData = JSON.parse(localStorage.getItem("userData") || "{}");
        
        // Create a merged object — completely replace with API response
        const updatedUserData = {
          ...localData,
          ...apiData
        };
        
        // Save back to localStorage
        localStorage.setItem("userData", JSON.stringify(updatedUserData));
        setFileList(null);
        setUserData(updatedUserData);

        // For profile picture, also update the preview with the new data
        if (field === "profile_picture") {
          setFields((prevFields) => ({
            ...prevFields,
            profilePicture: {
              ...prevFields.profilePicture,
              preview: apiData.thumbnailAvatarUrl || apiData.avatarUrl,
              value: apiData.avatarUrl,
              isEditing: false,
            },
          }));
        }
        setError('')

        message.success("Profile updated successfully");
      } else {
        message.error(response?.message || "Error saving changes");
      }
    } catch (error) {
      console.error("Profile update error:", error);
      message.error("An error occurred while saving changes");
    }
  };

  // Debug logging
 

  // The final image URL that will be passed to CustomAvatar
  const finalImageUrl = fields.profilePicture.preview || 
                        userData?.thumbnailAvatarUrl || 
                        userData?.avatarUrl;
  

  return (
    <Modal
      title="Profile"
      open={isProfileModalOpen}
      onCancel={handleProfileSettingsModalClose}
      footer={null}
      className="ec-modal mobile-profile-setting"
      width={800}
      style={{ top: 30, maxHeight: "80vh" }}
    >
      <Flex className="modal-sidebar">
        <Tabs
          tabPosition="left"
          activeKey={activeTabProfileModal}
          onChange={setActiveTabProfileModal}
          style={{ width: "100%" }}
          items={[
            {
              label: "Profile Settings",
              icon: <i className="fa-solid fa-gear"></i>,
              key: "1",
            },
          ]}
        />
      </Flex>
      <Flex className="modal-main">
        {activeTabProfileModal === "1" && (
          <div className="settings-content minimize-settings">
            <div>
              <Flex gap="small" vertical className="user-settings">
                <h4 className="tab-header">Profile Settings</h4>
                <Divider />
                
                {/* Full Name Section */}
                <Flex vertical className="settings">
                  <Flex justify="space-between" gap="small">
                    <h4 className="settings__title">Full Name</h4>
                    {!fields.fullName.isEditing && (
                      <Button
                        className="settings__edit"
                        onClick={() => handleEditToggle("fullName")}
                      >
                        <i className="fa-solid fa-pen-to-square"></i> Edit
                      </Button>
                    )}
                  </Flex>
                  
                  {fields.fullName.isEditing ? (
                    <Flex vertical gap="10px" className="settings__edit-mode">
                      <input
                        type="text"
                        value={fields.fullName.value}
                        onChange={(e) => handleChange("fullName", e.target.value)}
                        className="settings__input"
                      />
                      <Flex gap="small">
                        <Button
                          disabled={fields.fullName?.value?.trim().length === 0}
                          onClick={() => handleProfileEdit("fullName")}
                          className="settings__save primary-btn"
                        >
                          Save
                        </Button>
                        <Button
                          type="text"
                          onClick={() => handleEditToggle("fullName")}
                          className="settings__cancel text-btn"
                        >
                          Cancel
                        </Button>
                      </Flex>
                    </Flex>
                  ) : (
                    <Flex className="settings__description">
                      {userData?.fullName || "First Name"}
                    </Flex>
                  )}
                </Flex>
                
                <Divider />
                
                {/* Username Section */}
                <Flex vertical className="settings">
                  <Flex justify="space-between" gap="small">
                    <h4 className="settings__title">User Name</h4>
                    {!fields.userName.isEditing && (
                      <Button
                        className="settings__edit"
                        onClick={() => handleEditToggle("userName")}
                      >
                        <i className="fa-solid fa-pen-to-square"></i> Edit
                      </Button>
                    )}
                  </Flex>
                  
                  {fields.userName.isEditing ? (
                    <Flex vertical gap="10px" className="settings__edit-mode">
                      <input
                        type="text"
                        value={fields.userName.value}
                        onChange={(e) => handleChange("userName", e.target.value)}
                        className="settings__input"
                      />
                      <Flex gap="small">
                        <Button
                          disabled={fields.userName?.value?.trim().length === 0}
                          onClick={() => handleProfileEdit("userName")}
                          className="settings__save primary-btn"
                        >
                          Save
                        </Button>
                        <Button
                          type="text"
                          onClick={() => handleEditToggle("userName")}
                          className="settings__cancel text-btn"
                        >
                          Cancel
                        </Button>
                      </Flex>
                    </Flex>
                  ) : (
                    <Flex className="settings__description">
                      {userData?.userName || "first.name"}
                    </Flex>
                  )}
                </Flex>
                
                <Divider />
                
                {/* Profile Picture Section */}
                <Flex vertical className="settings">
                  <Flex justify="space-between" gap="small">
                    <h4 className="settings__title">Profile Picture</h4>
                    {!fields.profilePicture.isEditing && (
                      <Button
                        className="settings__edit"
                        onClick={() => handleEditToggle("profilePicture")}
                      >
                        <i className="fa-solid fa-pen-to-square"></i> Edit
                      </Button>
                    )}
                  </Flex>

                  <Flex className="settings__description" align="center" gap="middle">
                    <CustomAvatar
                      key={finalImageUrl || 'no-image'} // Force re-render when URL changes
                      size={60}
                      img={finalImageUrl}
                      userName={userData?.userName}
                    />

                    {fields.profilePicture.isEditing && (
                      <Flex gap="small" align="center">
                        <Upload
                          customRequest={handleFaviconUpload}
                          showUploadList={false}
                          accept="image/*"
                        >
                          <Button icon={<i className="fa-solid fa-upload"></i>}>
                            Upload New Image
                          </Button>
                        </Upload>
                        <Button
                          type="text"
                          onClick={() => handleEditToggle("profilePicture")}
                          className="settings__cancel text-btn"
                        >
                          Cancel
                        </Button>
                      </Flex>
                    )}
                  </Flex>
                </Flex>
                
                <Divider />

                {/* Change Password Section */}
                <Flex vertical className="settings">
                  <Flex justify="space-between" gap="small">
                    <h4 className="settings__title">Change Password</h4>
                    {!fields.password.isEditing && (
                      <Button
                        className="settings__edit"
                        onClick={() => handleEditToggle("password")}
                      >
                        <i className="fa-solid fa-pen-to-square"></i> Edit
                      </Button>
                    )}
                  </Flex>
                  
                  {fields.password.isEditing ? (
                    <Flex vertical gap="10px" className="settings__edit-mode">
                      <Password
                        type="password"
                        value={fields.password.value}
                        onChange={(e) => handleChange("password", e.target.value)}
                        className="settings__input"
                        placeholder="Enter new password"
                      />
                      {Error!=''&&<p style={{color:'red'}}>{Error}</p>}
                      <Flex gap="small">
                        <Button
                          disabled={fields.password?.value?.trim().length === 0}
                          onClick={() => handleProfileEdit("password")}
                          className="settings__save primary-btn"
                        >
                          Save
                        </Button>
                        <Button
                          type="text"
                          onClick={() => handleEditToggle("password")}
                          className="settings__cancel text-btn"
                        >
                          Cancel
                        </Button>
                      </Flex>
                    </Flex>
                  ) : (
                    <Flex className="settings__description">
                      ••••••••
                    </Flex>
                  )}
                </Flex>
              </Flex>
            </div>
          </div>
        )}
      </Flex>
    </Modal>
  );
};

export default ProfileModal;